import { match } from 'ts-pattern';
import { IUpdateFavoriteItemByIdUsecase } from '@modules/favorite/domain/ports/updateFavoriteItemById.usecase.port';
import { FavoriteType } from '@modules/libs/graphql/generated/graphql';
import { ModuleType } from '@shared/types/module.type';
import { left, right } from '@shared/utils/either.utils';
import { IFavoriteRepository } from '../ports/favorite.repository.port';
export class UpdateFavoriteItemByIdUsecase implements IUpdateFavoriteItemByIdUsecase {
  constructor(private readonly favoriteRepository: IFavoriteRepository) {}
  async handle(id: number, module: ModuleType): IUpdateFavoriteItemByIdUsecase.updateFavoriteItemByIdOutput {
    const favoriteType = match(module).with(ModuleType.Product, () => FavoriteType.Product).with(ModuleType.Collection, () => FavoriteType.Collection).with(ModuleType.Recipe, () => FavoriteType.Recipe).otherwise(() => null);
    if (!favoriteType) return left('Module Type not found');
    const result = await this.favoriteRepository.updateFavoriteItemById(id, favoriteType);
    const value = result.value;
    if (result.isLeft()) return left(value);
    return right(value);
  }
}